/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconChevronCompactRight = createReactComponent(
  "chevron-compact-right",
  "IconChevronCompactRight",
  [["path", { d: "M11 4l3 8l-3 8", key: "svg-0" }]]
);

export { IconChevronCompactRight as default };
//# sourceMappingURL=IconChevronCompactRight.js.map
